import { FC, ReactNode } from 'react';
import { Text } from '@qga/roo-ui/components';

export const ErrorModalBody: FC<{ content: ReactNode; resolution: ReactNode }> = ({ content, resolution }) => (
  <>
    <Text as="p" m={0}>
      {content}
    </Text>
    <Text as="p" mt={4} mb={0}>
      {resolution}
    </Text>
  </>
);
